
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 266.514 266.514"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M133.257 266.514C59.775 266.514 0 206.733 0 133.257S59.775 0 133.257 0s133.257 59.781 133.257 133.257-59.775 133.257-133.257 133.257zm0-255.636c-67.477 0-122.379 54.896-122.379 122.379S65.78 255.636 133.257 255.636s122.379-54.896 122.379-122.379S200.734 10.878 133.257 10.878z","fill":"#1aaa97"}}),_c('path',{attrs:{"d":"M210.35 127.818h-71.654V56.164a5.438 5.438 0 00-5.439-5.439 5.438 5.438 0 00-5.439 5.439v71.654H56.164a5.441 5.441 0 00-5.439 5.439 5.441 5.441 0 005.439 5.439h71.654v71.649a5.438 5.438 0 005.439 5.439 5.438 5.438 0 005.439-5.439v-71.649h71.654a5.441 5.441 0 005.439-5.439 5.44 5.44 0 00-5.439-5.439z","fill":"#1aaa97"}})])
          )
        }
      }
    